import { State, Action, StateContext, Actions, ofActionSuccessful } from '@ngxs/store';
import { StoreState, StoreInfoUser, StoreToken, GetInfoUser, StoreResource, StoreLifeHeroResource, GetSaleList, GetLifeHeroProductList } from './app.actions';
import { Injectable } from '@angular/core';
import { Dispatcher } from './base/dispatcher';
import { UsersService } from '../modules/users/users.service';
import { AccountService } from '../core';
import { QueryParams } from '../shared/model/query.params.model';
import { LifeHeroService } from '../modules/life-hero/life-hero.service';
declare let $: any;
export interface AppStateModel {
    states: any;
    userProfile: any;
    token: string;
    theme: any;
    resources: any;
    lifeHeroResources: any;
    sales: any;
    lifeHeroProducts: any;
    otp: any;
}

export function initAppState(): AppStateModel {
    return {
        userProfile: {},
        states: [],
        resources: {}
    } as AppStateModel;
}

@State<AppStateModel>({
    name: 'App',
    defaults: initAppState()
})
@Injectable()
export class AppState {

    constructor(
        private actions$: Actions,
        private dispatcher: Dispatcher,
        private accountService: AccountService,
        public usersService: UsersService,
        public lifeHeroService: LifeHeroService,
    ) {}

    @Action(StoreState)
    StoreTag(ctx: StateContext<AppStateModel>, action: StoreState) {
        const states = action.payload;
        ctx.patchState({
            states
        });
    }
    @Action(StoreToken)
    StoreToken(ctx: StateContext<AppStateModel>, action: StoreToken) {
        const token = action.payload;
        ctx.patchState({
            token
        });
    }
    @Action(StoreInfoUser)
    StoreInfoUser(ctx: StateContext<AppStateModel>, action: StoreInfoUser) {
        const userProfile = action.payload;
        this.accountService.authenticate(userProfile);
        ctx.patchState({
            userProfile
        });
    }
    @Action(StoreResource)
    StoreResource(ctx: StateContext<AppStateModel>, action: StoreInfoUser) {
        return this.usersService.getAllResource({})
        .subscribe((res: any) => {
            const resources = res.body.data || {};
            ctx.patchState({
                resources
            });
        })
    }
    @Action(StoreLifeHeroResource)
    StoreLifeHeroResource(ctx: StateContext<AppStateModel>, action: StoreInfoUser) {
        const lifeHeroResources = action.payload;
        ctx.patchState({
            lifeHeroResources
        });
    }
    @Action(GetSaleList)
    GetSaleList(ctx: StateContext<AppStateModel>, action: StoreInfoUser) {
        const req = new QueryParams();
        req.size = 1000;
        this.usersService
        .querySales(req)
        .subscribe(
            (res: any) => {
                if (!res.body) {
                    return;
                }
                ctx.patchState({
                    sales: res.body.data.list || []
                });
            }
        );
    }
    @Action(GetLifeHeroProductList)
    GetLifeHeroProductList(ctx: StateContext<AppStateModel>, action: StoreInfoUser) {
        const req = new QueryParams();
        req.size = 1000;
        this.lifeHeroService
        .queryProducts(req)
        .subscribe(
            (res: any) => {
                if (!res) {
                    return;
                }
                ctx.patchState({
                    lifeHeroProducts: res.data.rows || []
                });
            }
        );
    }
}
